import { SiteId } from 'wly-ecommerce-common';
import { RootState } from '@global/store/store';

export const cartSelector = (state: RootState) => state.cart;

export const cartUidSelector = (state: RootState) => state.cart.cartId;

export const billingInfoSelector = (state: RootState) => state.cart.billingInfo;
export const shippingInfoSelector = (state: RootState) =>
  state.cart.shippingInfo;
export const isGuestOrderSelector = (state: RootState) =>
  state.cart.isGuestOrder;
export const isWilaSelector = (state: RootState) =>
  state.cart.wSiteId === SiteId.WILA;
export const isSpectraBaseSelector = (state: RootState) =>
  state.cart.wSiteId === SiteId.SPECTRABASE;
export const isAgsSelector = (state: RootState) =>
  state.cart.wSiteId === SiteId.AGS;
export const isVetSelector = (state: RootState) =>
  state.cart.wSiteId === SiteId.VET;

export const subscriptionFrequencySelector = (state: RootState) =>
  state.cart.subscriptionFrequency;
